module.exports = function range(min, max, value) {
  return (value - min) / (max - min)
}